
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getAssetNameByCode, getAssetColor } from './get-asset';

@Component
export default class AssetTitle extends Vue {
  @Prop({ type: String })
  public title!: string;

  @Prop({ type: Number, required: false })
  public type!: number;

  private get computedAssetName() {
    if (this.title) {
      return this.title;
    } else {
      return getAssetNameByCode(Number(this.type));
    }
  }

  private get computedClass() {
    return getAssetColor(this.computedAssetName);
  }
}
